import http from './request';

/*
 * 【WL-28-0】迁移用药建议服务（草莓 -> 黑莓） 22.03.29
 */
// 检查提取码
const checkRedeem = (params = '') => http.get(`/blackberry/share/prescription/checkRedeem/${params}`);
// 立即查看（领取用药建议，如果是新就诊人就新增）
const checkPatient = (params) => http.post('/blackberry/share/prescription/checkPatient', params);
// 用药建议共享处方列表(已领取后的状态可见)
const getList = (params) => http.post('/blackberry/share/prescription/list', params);
// 用药建议共享处方详情
const getDetail = (params = '') => http.get(`/blackberry/share/prescription/info/${params}`);
// 获取门店以及二维码信息
const getStoreAndQrCode = (params) => http.post('/blackberry/share/prescription/getStoreAndQrCode', params);
// 修改用药建议数量
const updateMedicineNumber = (params) => http.post('/blackberry/share/prescription/updateMedicineNumber', params); // 用药建议药品数量修改

export {
  checkRedeem,
  checkPatient,
  getList,
  getDetail,
  getStoreAndQrCode,
  updateMedicineNumber
};
